import React from "react";
import * as aor from "react-admin";
import CustomerMappingGrid from "../../components/CustomerMappingGrid";
import CustomerDialog from "../../components/CustomerDialog";
import { Field } from "redux-form";

export default props => (
    <aor.Create {...props}>
        <aor.SimpleForm redirect="show">
            <CustomerDialog />

            <aor.TextInput source="name" validate={[aor.required()]} />
            <aor.TextInput
                source="email"
                validate={[aor.required(), aor.email()]}
            />
            <div style={{ width: "100%" }}>
                <Field
                    validate={aor.required()}
                    name="company_ids"
                    type="select-multi"
                    component={CustomerMappingGrid}
                    {...{
                        resource: "customers-mappings",
                        onEdit: true
                    }}
                />
            </div>
        </aor.SimpleForm>
    </aor.Create>
);



// WEBPACK FOOTER //
// ./src/resources/Customers/Create.js